/*@ngInject*/
const UIOverflowTooltipDirective = function ($document, $timeout, $sanitize) {

    let linkFunction = function ($scope, $elm, $attr) {

        let timeoutList = [],
            body = angular.element('body'),
            tooltip,
            position;

        function showTooltip(text) {
            position = $elm.offset();
            body.append(
                '<div class="uiTooltip">' +
                '<div class="message">' + $sanitize(text) + '</div>' +
                '<div class="arrowBackground"></div>' +
                '<div class="arrow"></div>' +
                '</div>');
            tooltip = angular.element('.uiTooltip');
            tooltip.css('opacity', 0);

            // verify if the top will be offscreen
            let positionTop = position.top - tooltip[0].offsetHeight - 1;
            if (positionTop < 0) {
                positionTop = position.top + $elm[0].offsetHeight + 10;
                tooltip.addClass('bottom');
            }

            tooltip.css('top', positionTop);
            tooltip.css('left', position.left - (tooltip[0].offsetWidth / 2) + ($elm[0].offsetWidth / 2 ));

            timeoutList.push($timeout(function () {
                if (tooltip) {
                    tooltip.css('opacity', 1);
                }
            }, 1));
        }

        function removeTooltip() {
            if (tooltip) {
                tooltip.css('opacity', 0);

                timeoutList.push($timeout(function () {
                    angular.element('.uiTooltip').remove();
                    tooltip = null;
                }, 200));
            }
        }

        $elm.on('mouseenter', function () {
            let displayTooltip = true;

            if ($elm[0].scrollWidth <= $elm.innerWidth()) {
                displayTooltip = false;
            }

            if (displayTooltip) {
                showTooltip($elm.text());
            }
        });
        $elm.on('mouseleave', removeTooltip);

        $scope.$on('$destroy', function () {
            $elm.off('mouseenter', showTooltip);
            $elm.off('mouseleave', removeTooltip);

            _.each(timeoutList, function (item) {
                $timeout.cancel(item);
            });
        });
    };

    return {
        restrict: 'A',
        link: linkFunction
    };
};

angular.module('umCore')
    .directive('uiOverflowTooltip', UIOverflowTooltipDirective);
